import { makeStyles } from '@material-ui/core/styles'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Tooltip from 'core/elements/tooltip/Tooltip'
import Theme from 'core/themes/model'
import Badge, { BadgeVariant } from 'pf9-ui-components/built/elements/badge/Badge'
import React from 'react'

type InfoBadgeProps = {
  label: string
  variant: BadgeVariant
  tooltipMsg?: string
  onInfoClick?: () => void
  showInfo?: boolean
}

const useStyles = makeStyles<Theme>((theme) => ({
  contentContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  iconClickable: {
    cursor: 'pointer',
    '&:hover': {
      color: theme.components.typography.active,
    },
  },
  iconContainer: {
    color: theme.palette.red[500],
  },
}))

const InfoBadge: React.FC<InfoBadgeProps> = ({
  label,
  variant,
  tooltipMsg,
  onInfoClick,
  showInfo = false,
}) => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.contentContainer}>
        <Badge variant={variant} text={label} />
        {showInfo && (
          <Tooltip message={tooltipMsg}>
            <span className={classes.iconClickable} onClick={onInfoClick}>
              <FontAwesomeIcon className={classes.iconContainer}>info-circle</FontAwesomeIcon>
            </span>
          </Tooltip>
        )}
      </div>
    </>
  )
}

export default InfoBadge
